import { gql } from '@apollo/client';

export const ADD_CLASS = gql`
  mutation AddClass($data: AddClassInput!) {
    addClass(data: $data) {
      id
      cover {
        source
        cdn01
        image
        video
        audio
        height
        width
        mimeType
      }
      color
      name
      description
      duration
      schedule
      deepLink
      type
      difficulty
      location
      category
    }
  }
`;

const UPDATE_CLASS = gql`
  mutation UpdateClass($data: UpdateClassInput!) {
    updateClass(data: $data) {
      id
      cover {
        source
        cdn01
        image
        video
        audio
        height
        width
        mimeType
      }
      color
      name
      description
      duration
      schedule
      deepLink
      type
      difficulty
      location
      category
    }
  }
`;
